import { StyleSheet } from 'react-native';
import { themes } from '../../theme/theme';

export const styles = StyleSheet.create({
  container: {
    position: 'absolute', // Overlay on the map
    top: 10, // Adjust as needed
    left: 10,
    right: 10,
    zIndex: 10, // Ensure it's above the map
    backgroundColor: themes.light.white[1], // Optional: For better visibility
    borderRadius: 8,
  },
  input: {
    height: 40,
    borderWidth: 1,
    borderRadius: 8,
    padding: 10,
  },
  suggestion: {
    padding: 10,
    borderBottomWidth: 1,
    borderColor: themes.light.brand_blue[3],
  },
});
